import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import registerApi, { setRegisterToken } from '../api/registerAxios';
import logo from '../assets/logo.js';

const label = { display:'block', fontSize:'11px', fontWeight:'500', textTransform:'uppercase', letterSpacing:'.5px', color:'var(--muted)', marginBottom:'5px' };
const input = { width:'100%', background:'var(--surface)', border:'1px solid var(--border-md)', borderRadius:'var(--radius)', padding:'12px 14px', fontSize:'18px', color:'var(--text)', outline:'none', fontFamily:'JetBrains Mono,monospace', letterSpacing:'2px', textTransform:'uppercase', textAlign:'center' };

// Public page staff open from the link in their invite email. The emailed code is the login:
// no email, no password, nothing to sign up for.
export default function StaffRegisterAuth() {
  const navigate = useNavigate();
  const location = useLocation();
  const [code,    setCode]    = useState('');
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(location.state?.notice || null);   // e.g. "Your code has expired" after being sent back here

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null); setLoading(true);
    try {
      const { data } = await registerApi.post('/login', { code: code.trim() });
      setRegisterToken(data.token);
      navigate('/staff-register/form', { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px', fontFamily:'Inter,sans-serif' }}>
      <div style={{ width:'100%', maxWidth:'400px' }}>
        <div style={{ textAlign:'center', marginBottom:'28px' }}>
          <div style={{ width:'64px', height:'64px', background:'#000', borderRadius:'50%', margin:'0 auto 14px', display:'flex', alignItems:'center', justifyContent:'center' }}>
            <img src={logo} alt="Car Saloon" style={{ width:'56px', height:'56px', objectFit:'contain' }}/>
          </div>
          <h1 style={{ fontSize:'20px', fontWeight:'600', color:'var(--text)', margin:0 }}>Staff Registration</h1>
          <p style={{ fontSize:'13px', color:'var(--muted)', marginTop:'4px' }}>Car Saloon</p>
        </div>

        <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', padding:'24px', boxShadow:'var(--shadow)' }}>
          {error && (
            <div role="alert" style={{ background:'var(--red-bg)', border:'1px solid rgba(163,45,45,0.2)', borderRadius:'var(--radius)', padding:'10px 14px', color:'var(--red)', fontSize:'13px', marginBottom:'16px', display:'flex', gap:'8px' }}>
              <i className="ti ti-alert-circle" style={{ flexShrink:0, marginTop:'1px' }} aria-hidden="true"/>
              <span>{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <label htmlFor="reg-code" style={label}>Your registration code</label>
            <input id="reg-code" value={code} onChange={e=>setCode(e.target.value)} required autoFocus autoComplete="off"
              autoCapitalize="characters" autoCorrect="off" spellCheck={false} placeholder="XXXXX-XXXXX" style={input}/>
            <p style={{ fontSize:'12px', color:'var(--muted)', lineHeight:1.5, margin:'8px 0 18px' }}>It’s in the email your manager sent you. There’s no password to create.</p>
            <button type="submit" disabled={loading || !code.trim()}
              style={{ width:'100%', padding:'11px', background:(loading||!code.trim())?'var(--hint)':'var(--blue)', border:'none', borderRadius:'var(--radius)', color:'#fff', fontSize:'14px', fontWeight:'500', cursor:(loading||!code.trim())?'not-allowed':'pointer' }}>
              {loading ? 'Opening...' : 'Open my registration'}
            </button>
          </form>
        </div>

        <p style={{ textAlign:'center', color:'var(--hint)', fontSize:'11px', marginTop:'20px', lineHeight:1.5 }}>
          Your code works for 72 hours and stops working once you submit your form.
        </p>
      </div>
    </div>
  );
}
